const HealthServicesList = () =>
	import(
		/* webpackChunkName: "healthserviceslist"*/ "@/views/HealthServicesList/index.vue"
	);
const HealthServicesCreate = () =>
	import(
		/* webpackChunkName: "healthservicescreate"*/ "@/views/HealthService/Create/index.vue"
	);
const HealthServicesView = () =>
	import(
		/* webpackChunkName: "healthservicesview"*/ "@/views/HealthService/index.vue"
	);
const HealthServicesEdit = () =>
	import(
		/* webpackChunkName: "healthservicesedit"*/ "@/views/HealthService/Edit/index.vue"
	);

export default [
	{
		path: "healthservices",
		name: "HealthServicesList",
		component: HealthServicesList,
		meta: {
			title: "DailyAdmin - Super health services list"
		}
	},
	{
		path: "healthservice/create",
		name: "HealthServicesCreate",
		component: HealthServicesCreate,
		meta: {
			title: "DailyAdmin - Health service create"
		}
	},
	{
		path: "healthservice/:id",
		name: "HealthServicesView",
		component: HealthServicesView,
		meta: {
			title: "DailyAdmin - Health service view"
		}
	},
	{
		path: "healthservice/:id/edit/",
		name: "HealthServicesEdit",
		component: HealthServicesEdit,
		meta: {
			title: "DailyAdmin - Health service edit"
		}
	}
];
